
import { Component, Prop, Vue } from 'vue-property-decorator';
import InternalTicketsRepositoryInterface from '@/services/Internal-Tickets/interfaces';

@Component({
  inject: ['internalTicketsRepository'],
})
export default class TicketContent extends Vue {
  @Prop() private title: string;
  @Prop() private description: string;

  private readonly internalTicketsRepository: InternalTicketsRepositoryInterface;

}

